import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

document.documentElement.lang = 'pt-BR';
document.title = 'Climorld';

const existingLink = document.querySelector("link[rel='icon']");
if (existingLink) {
  existingLink.remove();
}

const link = document.createElement("link");
link.rel = "icon";
link.href = process.env.PUBLIC_URL + "/icon.png";
document.head.appendChild(link);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
